import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoaderService } from '@shared/services';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UrlItem } from './abstractions/url-item';
import { urlWhiteList } from './constants/url-white-list';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private readonly loaderService = inject(LoaderService);

  private requestsInFlight = 0;

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T | never>> {
    if (this.urlNotWhiteListed(req.url, req.method)) {
      this.requestsInFlight++;
      this.loaderService.isHttpRequestLoading.next(true);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (this.urlNotWhiteListed(req.url, req.method)) {
          this.requestsInFlight--;
          if (this.requestsInFlight === 0) {
            this.loaderService.isHttpRequestLoading.next(false);
          }
        }
      })
    );
  }

  urlNotWhiteListed(reqUrl: string, method: string): boolean {
    return !urlWhiteList.some(
      (urlItem: UrlItem) =>
        reqUrl.includes(urlItem.url) && method === urlItem.method
    );
  }
}
